import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import SocialAccount from './components/SocialAccount';
import { useDispatch } from 'react-redux';
import { GET_SOCIAL_ACCOUNT_DATA, SOCIAL_ACCOUNT_ADD_ACCOUNT_DATA } from '../../../../actions/accountsActions';
import LoadingScreen from '../../../CommonComponents/LoadingScreen';

export default function ConnectAccount(){
    const params = useParams();
    const dispatch = useDispatch();
    const [loading,setLoading] = useState(true);
    const decodedId = params.encodedId;

    useEffect(()=>{
    const decodedValue = decodedId;
    dispatch(GET_SOCIAL_ACCOUNT_DATA(decodedValue,()=>setLoading(false)))
    dispatch(SOCIAL_ACCOUNT_ADD_ACCOUNT_DATA())
    localStorage.setItem('accountId',decodedValue);
    },[])
    return loading? <LoadingScreen/>:<SocialAccount/>
}